import { EstadoCivil } from "../interfaces/EstadoCivil";

const estadoCivilOpcoes = [
  //Array de Opções usadas no SELECT de atualizar cadastro e cadastrar proprietario
  { id: 1, label: "Solteiro", value: "SOLTEIRO" },
  { id: 2, label: "Casado", value: "CASADO" },
  { id: 3, label: "Separado", value: "SEPARADO" },
  { id: 4, label: "Divorciado", value: "DIVORCIADO" },
  { id: 5, label: "Viúvo", value: "VIUVO" },
];
export const estadoCivil: EstadoCivil[] = estadoCivilOpcoes.map((ec) => ({
  // Map do array
  id: ec.id,
  label: ec.label,
  value: ec.value,
}));
